import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { SessionTimeoutService } from '../../services/session-timeout/session-timeout.service';

@Component({
  selector: 'app-timeout-dialog',
  templateUrl: 'timeout-modal.component.html',
  styleUrls: ['timeout-modal.component.scss'],
  imports: [MatDialogTitle, CdkDrag, CdkDragHandle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class TimeoutModalComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  public countDown: number;

  get countDownDisplay(): string {
    const mins = Math.floor(this.countDown / 60)
      .toString()
      .padStart(2, '0');
    const secs = (this.countDown % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  }

  constructor(
    private readonly dialogRef: MatDialogRef<TimeoutModalComponent>,
    private readonly sessionTimeoutService: SessionTimeoutService
  ) {}

  ngOnInit(): void {
    this.countDown = this.sessionTimeoutService.getWarningSeconds();

    this.sessionTimeoutService.countdown$.pipe(takeUntil(this.destroy$)).subscribe((countdown) => (this.countDown = countdown));
    this.sessionTimeoutService.interrupt$.pipe(takeUntil(this.destroy$)).subscribe(() => this.close());
    this.sessionTimeoutService.timeout$.pipe(takeUntil(this.destroy$)).subscribe(() => this.close());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.dialogRef.close();
  }
}
